
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Features() {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: 'Unified Data Hub',
      description: 'Connect all your data sources in one centralized platform. From databases to APIs, spreadsheets to cloud storage - everything unified.'
    },
    {
      icon: 'ri-robot-line',
      title: 'Adaptive AI Agents',
      description: 'Intelligent agents that learn from your data patterns and adapt to your business needs, providing personalized insights and recommendations.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Real-Time Processing',
      description: 'Process and analyze data as it flows in. Get instant insights and alerts when important patterns or anomalies are detected.'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Ask in Plain English',
      description: 'No complex queries needed. Simply ask questions in natural language and get instant answers from your data.'
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Visualization Engine',
      description: 'Create stunning, interactive visualizations that tell your data story. From simple charts to complex dashboards.'
    },
    {
      icon: 'ri-video-line',
      title: 'Video Creation',
      description: 'Automatically generate video presentations of your data insights, perfect for stakeholder meetings and reports.'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaboration Workspaces',
      description: 'Share insights, collaborate on analysis, and work together seamlessly across teams and departments.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Audit & Compliance',
      description: 'Built-in audit trails, compliance reporting, and security features to meet enterprise governance requirements.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Everything You Need to Make Data Work for You
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Powerful features designed to transform how you interact with data, from collection to insights to action.
            Discover intelligent tools that adapt to your workflow and deliver meaningful results faster than ever before.
          </p>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="p-6 bg-gray-900 rounded-2xl border border-gray-800 hover:border-blue-500 transition-all duration-300 hover:transform hover:scale-105">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg mb-4">
                  <i className={`${feature.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Features Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6">Advanced Analytics Made Simple</h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Our platform combines the power of advanced AI with intuitive design, making complex data analysis accessible to everyone in your organization.
              </p>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-400 text-xl"></i>
                  <span>No coding or technical expertise required</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-400 text-xl"></i>
                  <span>Enterprise-grade security and compliance</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-400 text-xl"></i>
                  <span>Seamless integration with existing tools</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-400 text-xl"></i>
                  <span>24/7 support and dedicated success manager</span>
                </div>
              </div>
            </div>
            <div className="relative">
              {/* Image removed */}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
